import React from 'react';
import ReactDOM from 'react-dom/client';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../node_modules/bootstrap/dist/js/bootstrap.min.js"
import "bootstrap-icons/font/bootstrap-icons.css";
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import App from './App';
import Home from './Home';
import ThemeProvider from './themecontext/ThemeContext.js';

let myRoutes=createBrowserRouter([
    {
        path:"/",
        element:<App/>, children:[
            {index:true, element:<Home/>},
            {path:"*",element:<Navigate to="/" replace/>}
        ]
    },
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ThemeProvider><RouterProvider router={myRoutes}/></ThemeProvider>);